import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SharedModule } from 'src/app/layouts/full/shared/shared.module';
import { Client } from 'src/app/models/client.model';
import { ScanFile } from 'src/app/models/file.model';
import { Scan } from 'src/app/models/scan.model';
import { DesignEngineInsoles } from './interfaces/DesignEngineInsoles';
import { ProductDetails, ThreeDProducts } from '../modal-pricing-details/modal-pricing-details.component';
import { Roles, ScanModes, ServiceNames } from 'src/app/layouts/full/shared/Enums';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ChargeService } from 'src/app/services/charge.service';
import { ScanService } from 'src/app/services/scan.service';
import { HttpClient } from '@angular/common/http';
import { UserService } from 'src/app/services/user.service';
import { FormResponseService } from 'src/app/services/form-response.service';
import { ModalViewSubscriptionPlanService } from 'src/app/services/modal-view-subscription-plan.service';
import { environment } from 'src/environments/environment';
import axios, { AxiosHeaders } from 'axios';
import { FormResponse, InsolesPrescriptionResponse } from 'src/app/models/formResponse.model';
import { ModalSubscriptionPlanComponent } from '../modal-subscription-plan/modal-subscription-plan.component';
import { lastValueFrom } from 'rxjs';
import { ClientsService } from 'src/app/services/clients.service';
import { DefaultValues, toLeopoloyDesignEngine } from '../insoles-prescription/insolesPrescriptionMaper';
import { TranslateService } from '@ngx-translate/core';
import { User } from 'src/app/models/user.model';

interface Clinic {
  id: string;
  name: string;
}

interface PatientData {
  birthDate: string;
  clinic: Clinic;
  email: string;
  name: string;
  second_surname: string;
  sex: string;
  shoeSize: number;
  surname: string;
  weight: number;
}

interface DeviceInfo {
  appVersion: string;
}

interface Point {
  x: number;
  y: number;
  z: number;
  id: string;
  type: string;
}

interface Landmark {
  filename: string;
  id: string;
  points: Point[]
}

export interface Data {
  patientData: PatientData;
  deviceInfo: DeviceInfo;
  Landmarks: Landmark[]
}


@Component({
  selector: 'app-design-engine',
  standalone: true,
  imports: [SharedModule, ModalSubscriptionPlanComponent],
  templateUrl: './design-engine.component.html',
  styleUrl: './design-engine.component.scss',
  providers: [MessageService]
})
export class DesignEngineComponent {
  iframeUrl: SafeResourceUrl;
  token: string;
  scanId: string
  data: Data;
  isScanPopup: boolean = false;
  scanForm: FormGroup;
  signedZipUrl: string[] = [];
  loading: boolean = false;
  scanFiles: ScanFile[] = [];
  jsonFiles: ScanFile[] = [];
  order: Scan;
  versionName: string;
  version: string;
  respuesta: any
  isDesignEngineReady = false;
  buttonLabel: string = "Initializing engine...";
  isInsoleSubModal: boolean = true;
  role: string;
  engravedLogo: boolean = false;
  logo: string;
  engravingText: string;
  webhook: string;
  client: Client;
  insoleParametersData: DesignEngineInsoles = {
    left: {
      version: 3,
      emboss: {
        embossedText: {
          text: ""
        },
        embossedLogo: this.engravedLogo
      }
    },
    right: {
      version: 3,
      emboss: {
        embossedText: {
          text: ""
        },
        embossedLogo: this.engravedLogo
      }
    }
  };
  productName: string
  afoToken: string
  iframeAfoUrl: string
  afoScanForm: FormGroup
  iframeSpinalBraceUrl: string
  spinalBraceToken: string
  spinalBraceScanForm: FormGroup
  selectedProduct: ProductDetails
  clientId: string
  defaultValues: DefaultValues
  user: User

  // When custom logo is save in localstorage, show it
  public customLogo = "../../../assets/images/wiky-solutions.png";

  public scanModes: { label: string, value: ScanModes }[] = [];

  constructor(
    private sanitizer: DomSanitizer,
    private _activatedRoute: ActivatedRoute,
    private messageService: MessageService,
    private _chargeService: ChargeService,
    private fb: FormBuilder,
    private scanService: ScanService,
    private httpClient: HttpClient,
    public userService: UserService,
    private formResponseService: FormResponseService,
    public modalViewSubscriptionPlanService: ModalViewSubscriptionPlanService,
    public clientsService: ClientsService,
    private translateService: TranslateService
  ) {
    this.isScanPopup = true;
  }

  ngOnInit(): void {
    this.initializeScanModes();

    this.scanForm = this.fb.group({
      leftFoot: ["", Validators.required],
      leftFootScanMode: [ScanModes.nonWeighted, Validators.required],
      rightFoot: ["", Validators.required],
      rightFootScanMode: [ScanModes.nonWeighted, Validators.required],
      design: [""]
    });

    this.afoScanForm = this.fb.group({
      file: ["", Validators.required],
    });

    this.spinalBraceScanForm = this.fb.group({
      file: ["", Validators.required],
    });

    this._activatedRoute.queryParams.subscribe(async (params) => {
      this.scanId = params?.['id']
      this.productName = params?.['productName']
      console.log("ProductName: ", this.productName)

      const iframeToken = params?.['iframeToken']
      console.log('iframeToken', iframeToken);
      if (this.scanId) {
        if (!iframeToken) {
          await lastValueFrom(this.userService.validateToken());
        }

        await this.getScan(this.scanId)
        await this.getClient(this.clientId)

        if (this.userService.user) {
          this.role = this.userService.user.role
          this.user = this.userService.user
        }

        this.loadEngravinglogo()
        await this.loadDefaultValues()

        if (this.productName === 'PRODUCTS.INSOLES') {
          this._loginofLeopoly();
          this.selectedProduct = ThreeDProducts.insoles
        }

        if (this.productName === 'PRODUCTS.AFO') {
          this.selectedProduct = ThreeDProducts.afo
          this._loginOfLeopolyAFO()
        }

        if (this.productName === 'PRODUCTS.SPINAL_BRACE') {
          this._loginOfLeopolySpinalBrace()
          this.selectedProduct = ThreeDProducts.spinalBrace
        }

        this.showScanDialog(this.scanId);
      }
    })

    // Update the button label based on the engine status
    this.updateButtonLabel();

    this.checkIfHasCustomLogo();

    // Read the prescription and process to the design engine parameters
    this.processPrescriptionToDesignEngineParameters();

  }

  private initializeScanModes(): void {
    this.scanModes = [
      {
        label: this.translateService.instant('SCAN_MODES.foambox'),
        value: ScanModes.foambox
      },
      {
        label: this.translateService.instant('SCAN_MODES.non-weighted'),
        value: ScanModes.nonWeighted
      },
      {
        label: this.translateService.instant('SCAN_MODES.semi-weighted'),
        value: ScanModes.semiWeighted
      },
      {
        label: this.translateService.instant('SCAN_MODES.weighted'),
        value: ScanModes.weighted
      }
    ];
  }

  async getScan(scanId: string) {
    const scan = await lastValueFrom(this.scanService.getOne(scanId))
    this.data = scan.data
    this.webhook = scan.webhookOrderUrl ?? null
    this.clientId = scan.clientId
  }

  async getClient(clientId: string) {
    const client = await lastValueFrom(this.clientsService.getClientById(clientId))
    this.client = client
  }

  enableEngraving() {
    this.engravedLogo = true
    this.insoleParametersData.left.emboss.embossedLogo = true
    this.insoleParametersData.right.emboss.embossedLogo = true
  }

  loadEngravinglogo() {

    // Load SVG from the user if this has some, or load default wiky
    if (this.role === Roles.ROLE_INDIVIDUAL_CLIENT) {

      if (this.userService.user.engraving) {
        // Set engraved text
        this.setEngravedText(this.userService.user.engraving.text);

        // Load SVG Logo from user or use default wiky
        this.httpClient
          .get(this.userService.user.engraving.engravedLogo ? this.userService.user.engraving.logo : `assets/images/logos/wikySolutions_logo.svg`, { responseType: 'text' })
          .subscribe(value => {
            // Enable only if it's selected the engraved logo
            if (this.userService.user.engraving.engravedLogo) {
              this.enableEngraving();
            }
            this.logo = this.sanitizer.bypassSecurityTrustHtml(value).toString();
          });
      }
    }
    // Check if client has engraving logo assigned, if not load from distributor, or default one
    else if (this.role === Roles.ROLE_DISTRIBUTOR || this.role === Roles.ROLE_CUSTOMER) {

      console.log("client data: ", this.client);
      if (this.client.engraving) {

        // Set engraved text
        this.setEngravedText(this.client.engraving.text);

        this.httpClient
          .get(this.client.engraving.engravedLogo ? this.client.engraving.logo : `assets/images/logos/wikySolutions_logo.svg`, { responseType: 'text' })
          .subscribe(value => {
            // Enable only if it's selected the engraved logo
            if (this.client.engraving.engravedLogo) {
              this.enableEngraving();
            }
            this.logo = this.sanitizer.bypassSecurityTrustHtml(value).toString();
          });
      } else {
        // Set default wiky logo
        // Load SVG Logo from user or use default wiky
        this.httpClient
          .get(`assets/images/logos/wikySolutions_logo.svg`, { responseType: 'text' })
          .subscribe(value => {
            this.logo = this.sanitizer.bypassSecurityTrustHtml(value).toString();
          });
      }

    }

  }

  setEngravedText(text: string) {
    let textEngraving = text;

    // Replace variables to real values
    textEngraving = textEngraving.replace("%patient.name%", this.data["Patient Data"].name);
    textEngraving = textEngraving.replace("%patient.surname%", this.data["Patient Data"].surname);
    textEngraving = textEngraving.replace("%webhook%", (this.webhook && this.webhook.length > 0) ? this.webhook : "");
    textEngraving = textEngraving.replace("%id%", this.scanId);
    textEngraving = textEngraving.replace("%id.partial%", this.scanId.split('-')[0]);


    this.engravingText = textEngraving;

  }

  async loadDefaultValues(): Promise<void> {

    if (this.role === Roles.ROLE_INDIVIDUAL_CLIENT || this.role === Roles.ROLE_CUSTOMER) {

      if (this.userService.user.designEngineDefaultParameters) {
        const userDefaults = this.userService.user.designEngineDefaultParameters
        this.defaultValues = {
          left: {
            arch: {
              apexPosition: userDefaults.adjustArch.medial.apexPoint,
              archShape: userDefaults.adjustArch.medial.archShape,
              height: userDefaults.adjustArch.medial.apexHeight,
              proximalStartOffset: userDefaults.adjustArch.medial.startPoint
            },
            lateralArch: {
              apexPosition: userDefaults.adjustArch.lateral.apexPoint,
              archShape: userDefaults.adjustArch.lateral.archShape,
              height: userDefaults.adjustArch.lateral.apexHeight,
              proximalStartOffset: userDefaults.adjustArch.lateral.startPoint
            },
            emboss: {
              embossDepth: userDefaults.engravingParameters.depth,
              embossRotation: userDefaults.engravingParameters.rotation,
              embossedText: {
                fontSize: userDefaults.engravingParameters.fontSize,
                referencePointU: userDefaults.engravingParameters.positionU,
                referencePointV: userDefaults.engravingParameters.positionV,
                text: this.engravingText
              },
              embossedLogo: this.logo ? true : false
            }
          },
          right: {
            arch: {
              apexPosition: userDefaults.adjustArch.medial.apexPoint,
              archShape: userDefaults.adjustArch.medial.archShape,
              height: userDefaults.adjustArch.medial.apexHeight,
              proximalStartOffset: userDefaults.adjustArch.medial.startPoint
            },
            lateralArch: {
              apexPosition: userDefaults.adjustArch.lateral.apexPoint,
              archShape: userDefaults.adjustArch.lateral.archShape,
              height: userDefaults.adjustArch.lateral.apexHeight,
              proximalStartOffset: userDefaults.adjustArch.lateral.startPoint
            },
            emboss: {
              embossDepth: userDefaults.engravingParameters.depth,
              embossRotation: userDefaults.engravingParameters.rotation,
              embossedText: {
                fontSize: userDefaults.engravingParameters.fontSize,
                referencePointU: userDefaults.engravingParameters.positionU,
                referencePointV: userDefaults.engravingParameters.positionV,
                text: this.engravingText
              },
              embossedLogo: this.logo ? true : false
            }
          }
        }
      }
    } else if (this.role === Roles.ROLE_DISTRIBUTOR) {

      if (this.client && this.client.userLogin) {
        try {
          const user = await lastValueFrom(this.userService.getUserById(this.client.userLogin))

          if (user && user.designEngineDefaultParameters) {
            const userDefaults = user.designEngineDefaultParameters
            this.defaultValues = {
              left: {
                arch: {
                  apexPosition: userDefaults.adjustArch.medial.apexPoint,
                  archShape: userDefaults.adjustArch.medial.archShape,
                  height: userDefaults.adjustArch.medial.apexHeight,
                  proximalStartOffset: userDefaults.adjustArch.medial.startPoint
                },
                lateralArch: {
                  apexPosition: userDefaults.adjustArch.lateral.apexPoint,
                  archShape: userDefaults.adjustArch.lateral.archShape,
                  height: userDefaults.adjustArch.lateral.apexHeight,
                  proximalStartOffset: userDefaults.adjustArch.lateral.startPoint
                },
                emboss: {
                  embossDepth: userDefaults.engravingParameters.depth,
                  embossRotation: userDefaults.engravingParameters.rotation,
                  embossedText: {
                    fontSize: userDefaults.engravingParameters.fontSize,
                    referencePointU: userDefaults.engravingParameters.positionU,
                    referencePointV: userDefaults.engravingParameters.positionV,
                    text: this.engravingText
                  },
                  embossedLogo: this.logo ? true : false
                }
              },
              right: {
                arch: {
                  apexPosition: userDefaults.adjustArch.medial.apexPoint,
                  archShape: userDefaults.adjustArch.medial.archShape,
                  height: userDefaults.adjustArch.medial.apexHeight,
                  proximalStartOffset: userDefaults.adjustArch.medial.startPoint
                },
                lateralArch: {
                  apexPosition: userDefaults.adjustArch.lateral.apexPoint,
                  archShape: userDefaults.adjustArch.lateral.archShape,
                  height: userDefaults.adjustArch.lateral.apexHeight,
                  proximalStartOffset: userDefaults.adjustArch.lateral.startPoint
                },
                emboss: {
                  embossDepth: userDefaults.engravingParameters.depth,
                  embossRotation: userDefaults.engravingParameters.rotation,
                  embossedText: {
                    fontSize: userDefaults.engravingParameters.fontSize,
                    referencePointU: userDefaults.engravingParameters.positionU,
                    referencePointV: userDefaults.engravingParameters.positionV,
                    text: this.engravingText
                  },
                  embossedLogo: this.logo ? true : false
                }
              }
            }
          } else {
            if (this.userService.user && this.userService.user.designEngineDefaultParameters) {
              const userDefaults = this.userService.user.designEngineDefaultParameters
              this.defaultValues = {
                left: {
                  arch: {
                    apexPosition: userDefaults.adjustArch.medial.apexPoint,
                    archShape: userDefaults.adjustArch.medial.archShape,
                    height: userDefaults.adjustArch.medial.apexHeight,
                    proximalStartOffset: userDefaults.adjustArch.medial.startPoint
                  },
                  lateralArch: {
                    apexPosition: userDefaults.adjustArch.lateral.apexPoint,
                    archShape: userDefaults.adjustArch.lateral.archShape,
                    height: userDefaults.adjustArch.lateral.apexHeight,
                    proximalStartOffset: userDefaults.adjustArch.lateral.startPoint
                  },
                  emboss: {
                    embossDepth: userDefaults.engravingParameters.depth,
                    embossRotation: userDefaults.engravingParameters.rotation,
                    embossedText: {
                      fontSize: userDefaults.engravingParameters.fontSize,
                      referencePointU: userDefaults.engravingParameters.positionU,
                      referencePointV: userDefaults.engravingParameters.positionV,
                      text: this.engravingText
                    },
                    embossedLogo: this.logo ? true : false
                  }
                },
                right: {
                  arch: {
                    apexPosition: userDefaults.adjustArch.medial.apexPoint,
                    archShape: userDefaults.adjustArch.medial.archShape,
                    height: userDefaults.adjustArch.medial.apexHeight,
                    proximalStartOffset: userDefaults.adjustArch.medial.startPoint
                  },
                  lateralArch: {
                    apexPosition: userDefaults.adjustArch.lateral.apexPoint,
                    archShape: userDefaults.adjustArch.lateral.archShape,
                    height: userDefaults.adjustArch.lateral.apexHeight,
                    proximalStartOffset: userDefaults.adjustArch.lateral.startPoint
                  },
                  emboss: {
                    embossDepth: userDefaults.engravingParameters.depth,
                    embossRotation: userDefaults.engravingParameters.rotation,
                    embossedText: {
                      fontSize: userDefaults.engravingParameters.fontSize,
                      referencePointU: userDefaults.engravingParameters.positionU,
                      referencePointV: userDefaults.engravingParameters.positionV,
                      text: this.engravingText
                    },
                    embossedLogo: this.logo ? true : false
                  }
                }
              }
            }
          }
        } catch (error) {
          console.error("Error fetching user:", error);
        }

      }

    }

  }


  private _loginofLeopoly() {
    const payload = {
      "Username": environment.leopoly.username,
      "Password": environment.leopoly.password
    };

    this.userService.leopolyLogin(payload).subscribe({
      next: (res: any) => {
        this.token = res.token;
        const safeUrl: any = this._generateSafeUrl(this.token);
        if (safeUrl) {
          this.iframeUrl = safeUrl;

          // Capturar mensajes de Leopoly
          window.addEventListener("message", this.receiveMessage, false);
          console.log("Escuchando eventos de Leopoly...");
        }
      },
      error: (err) => {
        this.messageService.add({ severity: 'error', summary: 'error', detail: err?.error?.message });
      }
    });
  }


  private _loginOfLeopolyAFO() {
    const leoShapeUrl = 'https://edserafo.leopoly.com/insole/api/sign-in'

    const body = {
      Username: environment.leopoly.leoShape.username,
      Password: environment.leopoly.leoShape.password
    }

    const headers = new AxiosHeaders({
      'Content-Type': 'application/json'
    })

    axios.post(leoShapeUrl, body, { headers })
      .then(response => {
        this.afoToken = response.data.token
        const safeAfoUrl: any = this._generateSafeUrl(this.afoToken)
        if (safeAfoUrl) {
          this.iframeAfoUrl = safeAfoUrl
          // Capturar mensajes de Leopoly
          window.addEventListener("message", this.receiveMessage, false);
          console.log("Escuchando eventos de Leopoly...");
        }

      })
      .catch(error => {
        console.error("Error trying to login in LeoShape", error)
      })
  }

  private _loginOfLeopolySpinalBrace() {
    const credentials = {
      "Username": environment.leopoly.spinalBrace.username,
      "Password": environment.leopoly.spinalBrace.password
    }

    this.userService.leopolySpinalBraceLogin(credentials).subscribe({
      next: (res: any) => {
        this.spinalBraceToken = res.token;
        const safeUrl: any = this._generateSafeUrl(this.spinalBraceToken);
        if (safeUrl) {
          // Set the safe URL in the iframe
          this.iframeSpinalBraceUrl = safeUrl;
          // Capturar mensajes de Leopoly
          window.addEventListener("message", this.receiveMessage, false);
          console.log("Escuchando eventos de Leopoly...");
        }
      },
      error: (err) => {
        this.messageService.add({ severity: 'error', summary: 'error', detail: err?.error?.message });
      }
    });
  }

  private _generateSafeUrl(token: string): SafeResourceUrl {
    // Construct the URL with the token
    let url = `${environment.login_url}?token=${token}`;

    if (this.productName === 'PRODUCTS.AFO') {
      url = `${environment.afo_login_url}?token=${token}`
    }

    if (this.productName === 'PRODUCTS.SPINAL_BRACE') {
      url = `${environment.spinal_brace_login_url}?token=${token}`
    }

    // Sanitize the URL to make it safe
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }


  // This function is intended to handle messages received from an iframe

  // Add "any" type to "event" to avoid TypeScript errors
  // receiveMessage = (event: MessageEvent) => {
  //   const iframe = document.getElementById("design_engine") as HTMLIFrameElement;

  //   if (event.data && event.data.EVENT_NAME === "loaded_IFrame") {
  //     this.isDesignEngineReady = true;
  //     this.updateButtonLabel();
  //     let respuesta = this.respuesta;
  //     if (respuesta)
  //       iframe.contentWindow.postMessage(respuesta, "*");
  //   }

  //   if (event.data && event.data.EVENT_NAME === "model_export_start") {
  //     this._chargeService.chargeDesign(this.scanId).subscribe((res) => {
  //       console.log(res,"res");

  //       if (res) {
  //         let respuesta = {
  //           EVENT_NAME: "model_export_approved",
  //         };
  //         iframe.contentWindow.postMessage(respuesta, "*");
  //       }
  //     });
  //   }
  // };

  receiveMessage = async (event: MessageEvent) => {
    console.log("Received message from iframe:", event.data);
    let iframe;
    let service;

    if (this.productName == 'PRODUCTS.INSOLES') {
      iframe = document.getElementById("design_engine") as HTMLIFrameElement;
      service = ServiceNames.ThreeDInsolesDesign;
    }
    if (this.productName == 'PRODUCTS.AFO') {
      iframe = document.getElementById("design_engine_afo") as HTMLIFrameElement;
      service = ServiceNames.ThreeDAfoDesign;
    }
    if (this.productName == 'PRODUCTS.SPINAL_BRACE') {
      iframe = document.getElementById("design_engine_spinal_brace") as HTMLIFrameElement;
      service = ServiceNames.ThreeDSpinalBraceDesign;
    }

    if (event.data && event.data.EVENT_NAME === "loaded_IFrame") {
      console.log("Received loaded_IFrame");
      this.isDesignEngineReady = true;
      this.updateButtonLabel();
      let respuesta = this.respuesta;
      if (respuesta) {
        iframe.contentWindow.postMessage(respuesta, "*");
      }
    }

    if (event.data && event.data.EVENT_NAME === "user_library_changed" && event.data.data) {
      // Guardamos en BD las zonas para el usuario tal y como las da Leopoly (JSON string)
      const zonesJsonString = event.data.data

      // Verificar que es string antes de enviarlo
      if (typeof zonesJsonString === 'string') {
        await lastValueFrom(this.userService.updateDesignEngineZones(zonesJsonString))
      } else {
        console.error("Zones from Leopoly is not a string:", typeof zonesJsonString);
      }
    }

    if (event.data && event.data.EVENT_NAME === "model_export_start") {
      this._chargeService.chargeDesign(this.scanId, service).subscribe(
        (res) => {
          if (res) {
            let respuesta = {
              EVENT_NAME: "model_export_approved",
            };
            iframe.contentWindow.postMessage(respuesta, "*");
          }
        },
        (error) => {
          console.log("ERROR para obtener mensaje: ", error);
          if (error.status === 400 && error.error.message == "Client has not subscription to subscription needed") {
            let eventMessage = {
              EVENT_NAME: "model_export_cancelled",
              message_ID: "<unique_identifier>",
              data: { message: "3D design engine requires subscription" },
            };

            iframe.contentWindow.postMessage(eventMessage, "*");
            this.modalViewSubscriptionPlanService.showModal();
          }
        }
      );
    }

    if (event.data && event.data.EVENT_NAME === "closed_IFrame") {
      window.close();
    }
  };

  checkIfHasCustomLogo() {
    if (localStorage.getItem('customLogo')) {
      this.customLogo = localStorage.getItem('customLogo');
    }
  }

  /**Show model and select the values of lef and right */
  showScanDialog(orderId: string) {
    if (orderId) {
      this.scanService.getFiles(orderId).subscribe((files) => {
        // Filter scanFiles to include only paid STL files
        this.scanFiles = files.filter((scan) => (scan.type === "stl" || scan.type === "obj") && scan.paid === true);

        this.jsonFiles = files.filter((file) => file.type === "json");

        if (this.jsonFiles) {
          this.jsonFiles.forEach(jsonFile => {
            this.versionName = jsonFile.name;
            const versionMatch = this.versionName.match(/v(\d+)\.json/);
            if (versionMatch && versionMatch[1]) {
              this.version = versionMatch[1];
            }

          });
        }

        /**call getSignedZipUrl if orderId */
        this.getSignedZipUrl(orderId);
      })
    }

  }


  /**Get SignedZipUrl */
  getSignedZipUrl(orderId) {
    this.scanService.getSignedZipUrl(orderId).subscribe((res) => {
      this.signedZipUrl = res.signedZipUrl;
    })
  }



  async downloadFile(fileUrl: string): Promise<any> {
    try {
      const response = await fetch(fileUrl);
      if (!response.ok) {
        throw new Error(`Failed to fetch file: ${response.statusText}`);
      }
      const jsonData = await response.json();
      // Use the downloaded JSON data as needed
      return jsonData;
    } catch (error) {
      console.error('Error fetching file:', error);
      throw error; // Re-throw the error to be caught by the caller
    }
  }

  async loginofLeopoly() {
    this.isScanPopup = false;

    // If design it's selected, load the data
    if (this.scanForm.value.design) {
      // Use data from the selected design
      this.insoleParametersData = await this.downloadFile(this.scanForm.value.design.path);

    } else {
      // Use default data when no design is selected
      this.insoleParametersData.left.emboss.embossedText.text = this.engravingText ? this.engravingText : ""
      this.insoleParametersData.right.emboss.embossedText.text = this.engravingText ? this.engravingText : ""

    }

    const respuesta = {
      EVENT_NAME: "init_data",
      data: {
        scan_URLs: {
          right: this.scanForm.value.rightFoot.path,
          left: this.scanForm.value.leftFoot.path
        },
        scan_import_data: {
          right: {
            url: this.scanForm.value.rightFoot.path,
            format: this.scanForm.value.rightFoot ? this.scanForm.value.rightFoot.path.includes(".stl") ? "stl" : "obj" : null,
            scanMode: this.scanForm.value.rightFootScanMode
          },
          left: {
            url: this.scanForm.value.leftFoot.path,
            format: this.scanForm.value.leftFoot ? this.scanForm.value.leftFoot.path.includes(".stl") ? "stl" : "obj" : null,
            scanMode: this.scanForm.value.leftFootScanMode
          }
        },
        import_format: "stl",
        export_format: "stl",
        export_URL: this.signedZipUrl,
        engrave_text: {
          right: this.scanForm.value.rightFoot.name,
          left: this.scanForm.value.leftFoot.name,
        },
        file_name_data: {
          patient_name: this.data["Patient Data"].name,
          version: this.version ? Number(this.version) : 0,
          order_id: this.scanId
        },
        insole_parameters: this.insoleParametersData,
        embossed_logo_svg: this.logo,
        user_library: this.user?.designEngineZones || null,
      }
    };

    this.respuesta = respuesta
    window.addEventListener("message", this.receiveMessage, false);
    const iframe = document.getElementById("design_engine") as HTMLIFrameElement;

    iframe.contentWindow.postMessage(respuesta, "*");


    // const url = this.router.serializeUrl(
    //   this.router.createUrlTree(['/design/design-engine'], { queryParams: { id: this.order.ID, data: JSON.stringify(respuesta) } })
    // );

    // window.open(url, '_blank');
  }

  async loginofLeopolyAFO() {
    this.isScanPopup = false;

    const respuesta = {
      EVENT_NAME: "init_data",
      data: {
        scan_import_data: {
          url: this.afoScanForm?.value?.file?.path || null,
          format: this.afoScanForm?.value?.file?.name?.includes('stl') ? 'stl' : 'obj'
        },
        export_format: "stl",
        export_URL: this.signedZipUrl,
        file_name_data: {
          patient_name: this.data["Patient Data"].name,
          // patient_name: this.order.data["Patient Data"].name,
          version: this.version ? Number(this.version) : 0,
          order_id: this.scanId
        }
      }
    };

    this.respuesta = respuesta
    window.addEventListener("message", this.receiveMessage, false);
    const afoIframe = document.getElementById("design_engine_afo") as HTMLIFrameElement;

    afoIframe.contentWindow.postMessage(respuesta, "*");


    // const url = this.router.serializeUrl(
    //   this.router.createUrlTree(['/design/design-engine'], { queryParams: { id: this.order.ID, data: JSON.stringify(respuesta) } })
    // );

    // window.open(url, '_blank');
  }

  async loginofLeopolySpinalBrace() {
    this.isScanPopup = false;

    const respuesta = {
      EVENT_NAME: "init_data",
      data: {
        scan_import_data: {
          url: this.spinalBraceScanForm?.value?.file?.path || null,
          format: this.spinalBraceScanForm?.value?.file?.name?.includes('stl') ? 'stl' : 'obj'
        },
        export_format: "stl",
        export_URL: this.signedZipUrl,
        file_name_data: {
          patient_name: this.data["Patient Data"].name,
          // patient_name: this.order.data["Patient Data"].name,
          version: this.version ? Number(this.version) : 0,
          order_id: this.scanId
        }
      }
    };

    this.respuesta = respuesta
    window.addEventListener("message", this.receiveMessage, false);
    const spinalBraceIframe = document.getElementById("design_engine_spinal_brace") as HTMLIFrameElement;

    spinalBraceIframe.contentWindow.postMessage(respuesta, "*");


    // const url = this.router.serializeUrl(
    //   this.router.createUrlTree(['/design/design-engine'], { queryParams: { id: this.order.ID, data: JSON.stringify(respuesta) } })
    // );

    // window.open(url, '_blank');
  }


  // Add this method to update the button label based on the engine status
  updateButtonLabel() {
    this.buttonLabel = this.isDesignEngineReady ? "开始设计" : "正在初始化引擎...";
  }

  async processPrescriptionToDesignEngineParameters() {
    await this.loadDefaultValues()
    console.log("default values: ", this.defaultValues)
    this.scanService.getOne(this.scanId).subscribe((order) => {
      //If it contains formResponse it's possible to have "Insoles Prescription"
      if (order.formResponseId) {
        this.formResponseService.getOneByFormId(order.formResponseId).subscribe((formResponse: FormResponse) => {

          formResponse.questions.map((question) => {
            if (question.type === "insolesPrescription") {
              question = question as InsolesPrescriptionResponse;


              this.insoleParametersData = toLeopoloyDesignEngine(
                question,
                this.engravedLogo,
                this.defaultValues,
                question.shellType,
                question.lengthType,
                question.thinThickness
              )
            }
          })
          console.log(this.insoleParametersData);
        })
      }
    }, (err) => {
      console.log("Error on find Scan: ", err)

    })
  }
}
